 
 import * as firebase from 'firebase/app';
 import 'firebase/storage';
 import 'firebase/firestore';
 
 
 // Your web app's Firebase configuration
 var firebaseConfig = {
    apiKey: "AIzaSyBk9Tk_hDPdvW6ArHr2FmolLV0bETYC5gg",
    authDomain: "meow-firegram.firebaseapp.com",
    databaseURL: "https://meow-firegram.firebaseio.com",
    projectId: "meow-firegram",
    storageBucket: "meow-firegram.appspot.com",
    messagingSenderId: "65922459228",
    appId: "1:65922459228:web:9812b0d85d533609a9a899"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  const projectStorage = firebase.storage();
  const projectFirestore = firebase.firestore();
  const timestamp = firebase.firestore.FieldValue.serverTimestamp;

  export { projectStorage, projectFirestore, timestamp };